<template>
  <main>
    <trac-loading v-if="isLoading"></trac-loading>
    <trac-modal v-if="successModalCtrl" :cancel="false">
      <div class="flex flex-col justify-center items-center p-6 gap-6">
        <img src="./../../../assets/svg/pin-management/success-icon.svg" alt="" />
        <p class="text-sm">{{ successRes.message }}</p>

        <button data-test="done-button" class="border-none bg-none text-primaryBlue p-4 outline-none" @click="confirmSuccessPref">
          Done
        </button>
      </div>
    </trac-modal>


    <trac-back-button>Back</trac-back-button>

    <h3 class="my-8 font-bold text-sm">KYC(Settlement Preference)</h3>
    <div>
    <div class="shadow-lg rounded-md p-4 pt-8 w-9/12 mx-auto my-8 px-12 py-16">
      <div class="w-5/12">
        <img src="./../../../assets/svg/pin-management/settlement-pref.svg" alt=""
          class="bg-accentLight p-5 rounded-md" />

        <h3 class="mb-1 mt-5 font-bold text-lg text-primaryBlue">
          How do you want to be settled?
        </h3>
        <p class="text-xs">Select how you would want to be settled.</p>

        <div v-if="allowed.status" id="settlementSection" class="mt-12 mb-5 flex flex-col items-start justify-between pb-2 relative info-hold">
          <div v-for="type in settlementTypes" :key="type.id" class="flex items-center gap-5 py-4 border-b w-full">
            <div class="flex items-center gap-3">
              <div class="flex items-center gap-3">
                <input
                  type="radio"
                  :value="type.name"
                  :checked="currentSettlementType?.name === type.name"
                  @change="updateSettlementType(type.name)"
                  data-test="settlement-preference"
                  :id="`settlement-${type.name}`"
                  :disabled="type.name === 'instant' && !walletId" />
                <label :for="`settlement-${type.name}`" class="text-xs font-semibold cursor-pointer">
                  {{ type.title }}
                </label>
              </div>
              <div class="flex items-center justify-end relative">
                <button v-if="type.subOptions.length" @click="toggleDropdown(type.name)" class="text-xs cursor-pointer focus:outline-none">
                  <img
                    src="./../../../assets/svg/caret-down.svg"
                    alt=""
                    class="p-1 w-5 transition-transform duration-300 ease-in-out"
                    :class="{'caret-rotate': isDropdownOpen && currentDropdown === type.name}"
                  />
                </button>
                <img src="./../../../assets/svg/pin-management/info-icon.svg" alt="" class="info-icon ml-1" />
                <div class="absolute top-10 left-0 p-2 rounded-md bg-backgroundArea w-60 shadow-sm info-card">
                  <p>{{ type.description }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Dropdown section for subOptions -->
          <div v-if="isDropdownOpen && currentDropdown === currentSettlementType?.name" class="mt-4">
            <div class="flex flex-col gap-2">
              <div v-for="subOption in currentSettlementType?.subOptions" :key="subOption.id" class="flex items-center gap-5">
                <input
                  type="radio"
                  :value="subOption.name"
                  :checked="subOption.selected"
                  @change="toggleSamedayType(subOption.name)"
                  :id="`sub-settlement-${subOption.name}`" />
                <label :for="`sub-settlement-${subOption.name}`" class="text-xs cursor-pointer">
                  <div class="flex gap-2 items-center">
                    <img :src="subOption.icon" alt="" class="bg-accentLight p-2 rounded-md w-10 h-10" />
                    <div class="flex flex-col justify-between gap-1 mb-1 w-60">
                      <div class="mt-1 capitalize leading-3 font-bold">{{ subOption.label }}</div>
                      <span class="text-xxs leading-tight font-light">{{ subOption.description }}</span>
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="mt-8 border border-red-400 p-5 rounded-sm">
          <p class="text-xs text-red-700">
            {{ allowed.message }}
          </p>
        </div>

      </div>
      <!-- Instant Settlement -->
        <!-- <div :class="{ 'opacity-50': !walletId }" class="
            mt-8
            mb-5
            flex
            justify-between
            border-b
            pb-4
            items-center
            relative
            info-hold
          ">
          <div class="flex items-center gap-5">
            <div class="flex items-center gap-3">
              <input
                type="checkbox"
                value="instant"
                :checked="currentSettlementType === 'instant'"
                @change="updateSettlementType($event, 'instant')"
                data-test="settlement-preference"
                id="instant-settlement"
                :disabled="!walletId" />
              <label for="instant-settlement" class="text-xs font-semibold cursor-pointer">Instant settlement</label>
            </div>

          </div>
          <img src="./../../../assets/svg/pin-management/info-icon.svg" alt="" class="info-icon w-2" />
          <div class="
              absolute
              p-2
              rounded-md
              bg-backgroundArea
              w-60
              shadow-sm
              info-card
            ">
            <p class="" style="">
              Get instant settlement of all your transactions immediately the
              transaction is carried out, into your wallet account.
            </p>
          </div>
        </div> -->

        <!-- CTA to Setup Wallet if not done -->
        <!-- Create an outline box with lorem text -->
        <div id="noWalletId" v-if="!walletId" class="mt-8 border border-blue-400 p-5 rounded-sm">
          <p class="text-xs">
            You need to setup your wallet to use <b>instant settlement</b> option. Click the button
            below to setup your wallet.
          </p>
          <trac-button class="mt-4"
            @button-clicked="$router.push({ name: 'ConfirmPinInput', query: { ops: 'new_pin', onboarding: true } })">Setup
            Wallet
          </trac-button>
        </div>
      </div>
      <div class="flex justify-end mt-10">
        <trac-button data-test="confirm-button" v-if="currentSettlementType" @button-clicked="updateSettlementOption">
          CONFIRM
        </trac-button>
      </div>
    </div>
  </main>
</template>

<script>
import { eventBus } from "./../../../eventBus";

export default {
  data() {
    return {
      allowed: {
        status: true,
        message: '',
      },
      successModalCtrl: false,
      successRes: null,
      isLoading: false,
      settlementTypes: [],
      walletId: null,
      samedayType: [],
      isDropdownOpen: false,
      currentDropdown: null,
    };
  },
  computed: {
    currentSettlementType() {
      return this.settlementTypes.find((type) => type.selected) || null;
    },
  },
  async created() {
    this.isLoading = true;
    const wallet = await this.$store.dispatch("FETCH_WALLET_DETAILS");
    if (wallet.status) {
      this.walletId = wallet.data.walletid;
    }
    const res = await this.$store.dispatch("FETCH_SETTLEMENT_TYPE");
    if (res.status) {
      this.settlementTypes = res.data;
    } else {
      // debugger
      this.allowed.status = res.status;
      this.allowed.message = res.response.data.message || "An error occurred while fetching wallet details.";
      this.settlementTypes = [];
    }
    this.isLoading = false;
  },
  methods: {
    confirmSuccessPref() {
      this.successModalCtrl = false;
      this.$router.replace({
        name: this.$route.query.onboarding ? "MainWallet" : "SettlementPreference",
      });
    },
    updateSettlementType(typeName) {
      this.settlementTypes.forEach((type) => {
        type.selected = type.name === typeName;
        if (type.name === typeName && type.subOptions.length) {
          this.isDropdownOpen = true;
          this.currentDropdown = typeName;
        } else {
          this.isDropdownOpen = false;
          this.currentDropdown = null;
        }
      });
    },
    toggleSamedayType(optionName) {
      this.currentSettlementType.subOptions.forEach((subOption) => {
        subOption.selected = subOption.name === optionName;
      });
      this.samedayType = [optionName];
    },
    toggleDropdown(typeName) {
      if (this.currentDropdown === typeName) {
        this.isDropdownOpen = !this.isDropdownOpen;
      } else {
        this.isDropdownOpen = true;
        this.currentDropdown = typeName;
      }
    },
    async updateSettlementOption() {
      this.isLoading = true;
      if (this.currentSettlementType?.name === "sameday" && !this.samedayType[0]) {
        eventBus.$emit("trac-alert", {
          message: "Please select a Same Day Settlement option.",
        });
        this.isLoading = false;
        return;
      }
      const res = await this.$store.dispatch("UPDATE_SETTLEMENT_TYPE", {
        settlement_type: this.currentSettlementType?.name,
        sameday_type: this.samedayType[0] || "",
      });
      if (res.status) {
        this.successModalCtrl = true;
        this.successRes = res;
      } else {
        eventBus.$emit("trac-alert", {
          message: res.message,
        });
      }
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.info-hold {
  .info-icon {
    width: 0.65rem;
    cursor: pointer;

    &:hover+.info-card {
      display: block;
    }
  }

  .info-card {
    top: -7px;
    font-size: 0.65rem;
    left: 105%;
    display: none;
  }
}

.text-xxs{
  font-size: 0.6rem;
}
.caret-rotate {
  transform: rotate(180deg);
}
</style>